import React from 'react';

import { InputRow } from '../../../helpers/uiComponents/InputRow';
import { hideMessage, hidePopup, showMessage } from '../../../helpers/uiFunctions/uiActions';

import { addClient, addContact, addLocation } from '../../../data/serviceClients';
import { managerList, packageList, socialList, statusList } from '../../../helpers/uiFunctions/uiHelpers';


class NewClientForm extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			newClient: {
                name: null,
                status: "onboarding",
                manager: null,
                seoManager: null,
                velocity: 0,
                type: "client",
            },
            posting: false,
		}
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleNewClient = this.handleNewClient.bind(this);
	}
    handleUpdate(e) {
		var key = e.target.name;
		var value = e.target.value;

		if (e.target.type === "checkbox") {
			value = e.target.checked;
		}

        let newState = this.state.newClient;
        newState = {...newState, [key]: newState[key] = value}

        this.setState({newClient: newState});
		console.log(key, value, newState);
	}
    handleNewClient(e) {
        console.log("handle new client firing")
        showMessage("Adding New Client...");
        
        var body = this.state.newClient;
        var clientList = this.props.clientList;
		var clientNames = [];

		for(var i=0; i<clientList.length; i++){
			clientNames.push(clientList[i].name);
		}
        if (body.velocity === true) { body.velocity = 1; } else { body.velocity = 0; }
        if (body.name === "" || body.name === null) {
            hideMessage();
            alert("You must provide a client name");
            return false;
        }
        if (body.status === "Select..." || body.status === null) {
            hideMessage();
            alert("You must select a client status");
            return false;
        }
        if (clientNames.includes(body.name)) {
            hideMessage();
			alert("A client with this name already exists...");
			return false;
		}
        document.getElementById("addClientForm").reset();
        addClient(body).then(data => {
            console.log(data);
            hideMessage(data.success);
            if (data.success) {
                hidePopup("addClientForm");
                
                let clientCode = data.result.clientCode;
                // --------reload the client list and load the profile in the right column
                this.props.reloadClients();
                this.props.load(clientCode);

                // --------run async functions to add owner/billing/location
                let owner = { "clientCode": clientCode, "type": "Owner", }
                let billing = { "clientCode": clientCode, "type": "billing", }
                let location = { "clientCode": clientCode, "type": "billing", }
                addContact(owner);
                addContact(billing);
                addLocation(location);
            }
        });
	}

    render() {
        return(
            <React.Fragment>
                <section className="section">
                    <form className="form popup-form" id="addClientForm" style={{display: 'none'}}>
                        <i className="fas fa-times icon" onClick={() => hidePopup("addClientForm")} style={{float: 'right'}}></i>
                        <h3>Add New Client</h3>
                        <p className="client-error"></p>

                        <p><strong><em>* required</em></strong></p>
                        <InputRow onChange={this.handleUpdate} type="text" property="name" placeholder="* Client Name" id="addClientInput" />
                        <InputRow
                            onChange={this.handleUpdate}
                            label="* Status"
                            type="select"
                            property="status"
                            id="clientStatus"
                            options={statusList}
                            hideSelectOption="true"
                        />

                        <p><strong><em>optional</em></strong></p>
                        <InputRow
                            onChange={this.handleUpdate}
                            label="Account Manager"
                            type="select"
                            property="accountManager"
                            id="accountManager"
                            options={managerList}
                        />
                        <InputRow
                            onChange={this.handleUpdate}
                            label="Social Media Manager"
                            type="select"
                            property="seoManager"
                            id="seoManager"
                            options={socialList}  
                        />
                        <InputRow onChange={this.handleUpdate} label="Is this a velocity client?" type="checkbox" property="velocity" id="velocity" defaultChecked />
                        <InputRow
                            onChange={this.handleUpdate}
                            label="Service Package"
                            type="select"
                            property="servicePackage"
                            id="servicePackage"
                            options={packageList}
                        />

                        <input onClick={this.handleNewClient} type="button" id="add-client-button" className="button is-info" value="Add Client" />
                    </form>
                </section>
            </React.Fragment>
        )
    }
}
export default NewClientForm;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientExplorer/AddClientForm.js